import React from 'react';

interface FullPageMessageProps {
  /** Icon rendered inside a rounded square. Receives a className for sizing. */
  icon: React.ReactNode;
  /** Background color for the icon container. CSS variable string. */
  iconBg: string;
  title: string;
  description?: React.ReactNode;
  /** Optional action button or link */
  action?: React.ReactNode;
  /** Optional extra content below the description (e.g. role info) */
  extra?: React.ReactNode;
}

const FullPageMessage: React.FC<FullPageMessageProps> = ({
  icon,
  iconBg,
  title,
  description,
  action,
  extra,
}) => (
  <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--page-bg)' }}>
    <div className="max-w-md w-full text-center px-6 animate-fade-up">
      <div
        className="mx-auto h-16 w-16 flex items-center justify-center rounded-2xl mb-8 animate-float"
        style={{ background: iconBg }}
      >
        {icon}
      </div>
      <h1
        className="text-3xl font-extrabold tracking-tight mb-2"
        style={{ color: 'var(--text-primary)', letterSpacing: '-0.025em' }}
      >
        {title}
      </h1>
      {description && (
        <p className="mb-4 text-sm" style={{ color: 'var(--text-muted)' }}>
          {description}
        </p>
      )}
      {extra && <div className="mb-6">{extra}</div>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  </div>
);

export default FullPageMessage;
